const TeaTimeFoxtrotLead = {
    name: "Tea-Time Foxtrot",
    bpm: 108,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default TeaTimeFoxtrotLead;